import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import { Modal } from 'react-bootstrap';

class QueryDialog extends React.Component {
  renderField = ({
    input,
    label,
    type,
    disabled,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={label}
          type={type}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );
  render() {
    return (
      <Modal show={this.props.show}>
        <Modal.Header>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-hidden="true"
            onClick={this.props.onClose}
          >
            &times;
          </button>
          <h4 className="modal-title">Save Query</h4>
        </Modal.Header>
        <Modal.Body>
          {/* <pre>
            {this.props.query}
          </pre> */}
          <form className="form-horizontal" onSubmit={this.props.handleSubmit}>
            <Field
              name="title"
              component={this.renderField}
              type="text"
              placeholder="Title"
              label="Title"
            />
            <Field
              name="description"
              component={this.renderField}
              type="text"
              placeholder="Description"
              label="Description"
            />
            {this.props.initialValues && this.props.initialValues.query && (
              <pre className="hide">{this.props.initialValues.query}</pre>
            )}
            <div className="form-actions">
              <div className="row">
                <div className="col-md-12">
                  <button
                    onClick={this.props.onClose}
                    className="btn btn-default"
                    type="button"
                  >
                    Cancel
                  </button>{' '}
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={this.props.pristine || this.props.submitting}
                  >
                    <i className="fa fa-save" /> Save
                  </button>
                </div>
              </div>
            </div>
            {this.props.isLoading && (
              <div className="cover">
                <div className="spinner inline" />
              </div>
            )}
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

export default connect((state, props) => ({
  enableReinitialize: true,
}))(reduxForm({ form: 'saveQuery' })(QueryDialog));



// WEBPACK FOOTER //
// ./src/routes/management/components/QueryBuilder/QueryDialog.js